import React from 'react';

const SuccessBridge: React.FC = () => {
    const scrollToCaseStudies = (e: React.MouseEvent) => {
        e.preventDefault();
        const element = document.getElementById('case-study');
        if (element) {
            const headerOffset = 100;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.scrollY - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <section className="py-12 md:py-20 bg-white relative overflow-hidden">
            <div className="container-xl relative z-10">
                <div
                    onClick={scrollToCaseStudies}
                    className="group relative w-full flex flex-col md:flex-row items-center justify-between p-8 md:p-12 bg-[#021226] rounded-[3rem] cursor-pointer hover:bg-[#0a1e36] transition-all duration-500 shadow-2xl shadow-blue-900/20 overflow-hidden border border-white/5"
                >
                    {/* Decorative background */}
                    <div className="absolute top-0 right-0 w-96 h-96 bg-[#FF5C00]/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none transition-opacity group-hover:opacity-20 opacity-10"></div>
                    <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-500/10 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

                    <div className="relative z-10 flex flex-col md:flex-row items-center gap-6 md:gap-10 text-center md:text-left w-full md:w-auto">
                        <div className="w-20 h-20 rounded-3xl bg-white/5 border border-white/10 flex items-center justify-center text-[#FF5C00] group-hover:bg-[#FF5C00] group-hover:text-white transition-all duration-300 shadow-2xl group-hover:scale-110 group-hover:rotate-3">
                            <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                        </div>
                        <div className="max-w-xl">
                            <h3 className="text-2xl md:text-4xl font-black text-white tracking-tight mb-3 group-hover:text-white transition-colors">Still Thinking About it?</h3>
                            <p className="text-slate-400 font-medium text-sm md:text-lg group-hover:text-slate-300 transition-colors">
                                <span className="md:hidden">See how 40+ furniture retailers transformed their sales with precision AR. Proof that scales.</span>
                                <span className="hidden md:block">See the real-world metrics from 40+ furniture retailers who transformed their sales with OmniView Labs. Proof that scales.</span>
                            </p>
                        </div>
                    </div>

                    <div className="relative z-10 mt-8 md:mt-0 w-full md:w-auto">
                        <button className="w-full md:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-white text-[#021226] font-black uppercase tracking-widest text-xs rounded-2xl shadow-xl group-hover:bg-[#FF5C00] group-hover:text-white group-hover:-translate-y-1 transition-all duration-300">
                            See Success Stories
                            <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SuccessBridge;
